import type { HelpFile } from '../../types/help'
import { ConnectorsTestIds } from '../../../testids/ConnectorsTestIds'

export const connectorsHelp: HelpFile = {
  texts: {
    [ConnectorsTestIds.connectorsWelcomeCard]:
      'Hub for inbound and outbound connectors — pick a sub-section to manage data import or provisioning configurations.',
  },
}
